"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");

var SupplierAgreementUpdateDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SupplierAgreementUpdateDTO, _DomainObject_1$Domai);

  function SupplierAgreementUpdateDTO(id, preferred, regularPurchasePrice, regularPurchasePriceNett, promoPurchasePrice, promoPurchasePricePlus, promoPurchaseStartDate, promoPurchaseEndDate, purchaseForecastSMPA, confirmedPurchaseForecastSMPA, obligatoryToBuy, split, promoVolume, minimalVolume, maximalVolume, unitBackDiscount, supplierInvoice, unitBackDiscountRealization, secondaryPlacementFee, leafletFee, warningFlags, costPriceFormat, lastPromoPurchaseUpdate) {
    var _this;

    _classCallCheck(this, SupplierAgreementUpdateDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementUpdateDTO).call(this));
    _this.id = id;
    _this.preferred = preferred;
    _this.regularPurchasePrice = regularPurchasePrice;
    _this.regularPurchasePriceNett = regularPurchasePriceNett;
    _this.promoPurchasePrice = promoPurchasePrice;
    _this.promoPurchasePricePlus = promoPurchasePricePlus;
    _this.promoPurchaseStartDate = promoPurchaseStartDate;
    _this.promoPurchaseEndDate = promoPurchaseEndDate;
    _this.purchaseForecastSMPA = purchaseForecastSMPA;
    _this.confirmedPurchaseForecastSMPA = confirmedPurchaseForecastSMPA;
    _this.obligatoryToBuy = obligatoryToBuy;
    _this.split = split;
    _this.promoVolume = promoVolume;
    _this.minimalVolume = minimalVolume;
    _this.maximalVolume = maximalVolume;
    _this.unitBackDiscount = unitBackDiscount;
    _this.supplierInvoice = supplierInvoice;
    _this.unitBackDiscountRealization = unitBackDiscountRealization;
    _this.secondaryPlacementFee = secondaryPlacementFee;
    _this.leafletFee = leafletFee;
    _this.warningFlags = warningFlags;
    _this.costPriceFormat = costPriceFormat;
    _this.lastPromoPurchaseUpdate = lastPromoPurchaseUpdate;
    return _this;
  }
  /** returns true when dto does not contain any change */


  _createClass(SupplierAgreementUpdateDTO, null, [{
    key: "isEmpty",
    value: function isEmpty(dto) {
      return utils_1.Utils.isUndefined(dto.preferred) && utils_1.Utils.isUndefined(dto.regularPurchasePrice) && utils_1.Utils.isUndefined(dto.regularPurchasePriceNett) && utils_1.Utils.isUndefined(dto.promoPurchasePrice) && utils_1.Utils.isUndefined(dto.promoPurchasePricePlus) && utils_1.Utils.isUndefined(dto.promoPurchaseStartDate) && utils_1.Utils.isUndefined(dto.promoPurchaseEndDate) && utils_1.Utils.isUndefined(dto.purchaseForecastSMPA) && utils_1.Utils.isUndefined(dto.confirmedPurchaseForecastSMPA) && utils_1.Utils.isUndefined(dto.obligatoryToBuy) && utils_1.Utils.isUndefined(dto.split) && utils_1.Utils.isUndefined(dto.promoVolume) && utils_1.Utils.isUndefined(dto.minimalVolume) && utils_1.Utils.isUndefined(dto.maximalVolume) && utils_1.Utils.isUndefined(dto.unitBackDiscount) && utils_1.Utils.isUndefined(dto.supplierInvoice) && utils_1.Utils.isUndefined(dto.unitBackDiscountRealization) && utils_1.Utils.isUndefined(dto.secondaryPlacementFee) && utils_1.Utils.isUndefined(dto.leafletFee) && utils_1.Utils.isUndefined(dto.warningFlags) && utils_1.Utils.isUndefined(dto.costPriceFormat) && utils_1.Utils.isUndefined(dto.lastPromoPurchaseUpdate);
    }
  }]);

  return SupplierAgreementUpdateDTO;
}(DomainObject_1.DomainObject);

exports.SupplierAgreementUpdateDTO = SupplierAgreementUpdateDTO;